import { Checkbox } from '@ksyos/design-system';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import type { PatientAlternativeAddressType } from '@common/validation/customControls/patientContactDetailsSchema';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function AlternativeAddressCheckbox() {
    const {
        data: { sendToAlternativeAddress },
    } = useProcessActivityEditContext<PatientAlternativeAddressType>();
    const {
        field: { label },
        onChange,
    } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();

    return (
        <Checkbox
            checked={sendToAlternativeAddress ?? false}
            label={label}
            onChange={(event) => onChange(event.target.checked)}
            sx={{ marginY: 4 }}
        />
    );
}
